var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22367 0.173445C8.27954 0.228286 8.32386 0.293434 8.3541 0.365159C8.38434 0.436884 8.3999 0.513776 8.3999 0.591431C8.3999 0.669086 8.38434 0.745978 8.3541 0.817703C8.32386 0.889427 8.27954 0.954576 8.22367 1.00942L1.44898 7.67594L8.22367 14.3425C8.27945 14.3973 8.32369 14.4625 8.35387 14.5342C8.38405 14.6059 8.39959 14.6828 8.39959 14.7604C8.39959 14.8381 8.38405 14.9149 8.35387 14.9867C8.32369 15.0584 8.27945 15.1235 8.22367 15.1784C8.1679 15.2333 8.10169 15.2769 8.02882 15.3066C7.95596 15.3363 7.87785 15.3516 7.79898 15.3516C7.72011 15.3516 7.64201 15.3363 7.56914 15.3066C7.49627 15.2769 7.43006 15.2333 7.37429 15.1784L0.176105 8.09392C0.120243 8.03908 0.0759239 7.97393 0.0456839 7.90221C0.0154438 7.83048 -0.00012207 7.75359 -0.00012207 7.67594C-0.00012207 7.59828 0.0154438 7.52139 0.0456839 7.44967C0.0759239 7.37794 0.120243 7.31279 0.176105 7.25795L7.37429 0.173445C7.43001 0.118465 7.4962 0.0748452 7.56908 0.0450826C7.64196 0.0153201 7.72008 0 7.79898 0C7.87788 0 7.95601 0.0153201 8.02888 0.0450826C8.10176 0.0748452 8.16795 0.118465 8.22367 0.173445Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackVector);
export default __webpack_public_path__ + "static/media/backVector.6709fa92f187b4948dca2f006548b986.svg";
export { ForwardRef as ReactComponent };